export default "__VITE_ASSET__BkDhKMEm__"